import React, { useEffect, useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';

import { text_truncate } from '../../../../helpers';
import { FILTER_KEYS, PLAY_TYPE, SCOPE } from '../../../../config/constants';
import { useRouter } from '../../../../helpers/customHooks';
import {
  BasicSimpleSelectorItem,
  SimpleSelectorPresentationalPropsType,
  SimpleSelectorPropsType,
  SimpleSelectorWrappedPropsType
} from './types';
import { useFiltersState } from '../../../../store/hooks';
import { ParamWrapper } from '../ParamWrapper';

import './styles.scss';

export const SimpleSelectorPresentational = <T extends BasicSimpleSelectorItem, >
({
   forceScope,
   filterData,
   changeFilterData,
   defaultItem,
   onApply,
   show,
   close,
   open,
   type,
   style,
   menuStyle = undefined,
   listItemStyle = undefined,
   hidden
 }: SimpleSelectorPresentationalPropsType<T>) => {
  
  const { specificScope: specificScopePrime } = useRouter();
  const [disablePreGame, setDisablePreGame]=useState(false);
  const [isPreGame, setisPreGame]=useState(false);
  const {
    [FILTER_KEYS.QUARTER]: quarterSelected } = useFiltersState(forceScope!, FILTER_KEYS.QUARTER);
  useEffect(() => {
    if (filterData === undefined && defaultItem !== undefined) {
      changeFilterData(defaultItem);
    }
  }, [defaultItem]);

  const specificScope = forceScope || specificScopePrime;
  const [appliqued, setAppliqued] = useState(false);
  const [optionSelected, setOptionSelected] = useState<T>(filterData!);
  useEffect(() => {
    if(quarterSelected && type.name === PLAY_TYPE.name){
      const isPreGameSelected = quarterSelected.length === 0 || quarterSelected.some(quarter => quarter.value === 'Q0');
      setisPreGame(quarterSelected.length === 1 && quarterSelected[0].value === 'Q0' );
      if(!isPreGameSelected){
        setDisablePreGame(true);
      }else{
        setDisablePreGame(false);
      }
    } 
    
  }, [quarterSelected, optionSelected]);
 
  const { types, title } = type;
  const li: JSX.Element[] = [];
  types.forEach((type) => {
    li.push(
      <li
        key={(specificScope ? specificScope + '-' : '') + JSON.stringify(type)}
        className="li-simple-selector"
        style={listItemStyle ? listItemStyle : undefined}
      >
        <div className="radio" style={((type.name === 'In-Play' || type.name === 'Out-Of-Play') && isPreGame) ||
         (type.name === 'Pre-Game' && disablePreGame) ? { opacity: '0.5', pointerEvents: 'none' } : { fontSize: '12px' }}>
          <input
            id={(specificScope ? specificScope + '-' : '') + 'radio-' + JSON.stringify(type)}
            name={(specificScope ? specificScope + '-' : '') + `radio-${type.name}`}
            type="radio"
            checked={JSON.stringify(optionSelected) === JSON.stringify(type)}
            onChange={() => {setOptionSelected(type);
              if(specificScope === SCOPE.ENTITIES.NOC.PAGE || specificScope === SCOPE.HEALTH.PAGE || specificScope === SCOPE.PRACTICES.PAGE || specificScope === SCOPE.PLAYERS.PAGE
                || specificScope === SCOPE.GAMES.PAGE){
                close();
                setAppliqued(true);
                changeFilterData(type);
              if (onApply) {
                onApply(type, filterData!);
                } 
              }
            }}
          />
          <label
            htmlFor={(specificScope ? specificScope + '-' : '') + 'radio-' + JSON.stringify(type)}
            style={{ fontWeight: JSON.stringify(optionSelected) === JSON.stringify(type) ? 'bold' : undefined }}
            className="radio-label"
          >
            {type.name}
          </label>
        </div>
      </li>)
    ;
  });
  const onOpen = () => {
    open();
    setOptionSelected(filterData!);
  };
  const onApplyHandle = (flag?: boolean) => {
    close();
    setAppliqued(true);
    changeFilterData(optionSelected);
    if (onApply && !flag) {
      onApply(optionSelected, filterData!);
    }
  };
  return (
    <Dropdown
      show={show}
      onToggle={show ? close : onOpen}
      className={`style-${type.name}`}
      style={hidden ? { display: 'none' } : {}}
    >
      <Dropdown.Toggle
        id="dropdown-basic"
        className="btn-border more-arrow-after view-data-width"
        style={(specificScope === SCOPE.ENTITIES.NOC.PAGE || specificScope === SCOPE.HEALTH.PAGE ?
          { width: '155px', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }
          : { width: '114px' })}
      >
        <label className={appliqued ? 'appliqued' : ''}>{title}</label>
        {filterData ? text_truncate(filterData.name, specificScope === SCOPE.ENTITIES.NOC.PAGE || specificScope === SCOPE.HEALTH.PAGE ? 22 : 12) : 'Select'}
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="simple-selector-dropdown-menu"
        style={menuStyle ? menuStyle : { ...style, width: '195px', minWidth: '165px' }}
      >
        <ul className="ul-simple-selector scroll-style-zebra-sports">
          {li}
        </ul>
        {(specificScope !== SCOPE.ENTITIES.NOC.PAGE && specificScope !== SCOPE.HEALTH.PAGE && specificScope !== SCOPE.PRACTICES.PAGE && specificScope !== SCOPE.PLAYERS.PAGE
        && specificScope !== SCOPE.GAMES.PAGE) ? 
           <div className="footer-s">
           <Button className="btn-transparet" onClick={close}>
             Cancel
           </Button>
           <Button className="btn-blue" onClick={()=>onApplyHandle(type.name === PLAY_TYPE.name && optionSelected.name !== 'Totals' && 
            (quarterSelected?.length === 0 || quarterSelected?.some(value => value.value === 'Q0')))}>
             Apply
           </Button>
           </div>
        :
          ''
        }
      </Dropdown.Menu>
    </Dropdown>
  );
};

const SimpleSelectorWrapped = <T extends BasicSimpleSelectorItem, >({
                                                                      type,
                                                                      forceScope,
                                                                      changeFilterDataWrapped,
                                                                      ...restProps
                                                                    }: SimpleSelectorWrappedPropsType<T>) => {
  
  const { specificScope: specificScopePrime } = useRouter();
  const specificScope = forceScope || specificScopePrime;
  const { [type.filterKey]: filtersState } = useFiltersState(specificScope, type.filterKey);
  
  return (
    <SimpleSelectorPresentational<T>
      {...restProps}
      type={type}
      forceScope={forceScope}
      filterData={filtersState as T}
      changeFilterData={(item: T) => changeFilterDataWrapped(item)()}
    />
  );
};

const SimpleSelector = <T extends BasicSimpleSelectorItem, >(props: SimpleSelectorPropsType<T>) => {
  return (
    <ParamWrapper<T, SimpleSelectorPropsType<T>>
      fromUrlSearchParam={(cad, props): T => {
        return props.type.types.find(value => JSON.stringify(value.value) === cad) || props.type.types[props.type.defaultIndex];
      }}
      toUrlSearchParam={(selectedItem: T) => {
        if (selectedItem) {
          return JSON.stringify(selectedItem.value);
        }
        return '';
      }}
      Component={SimpleSelectorWrapped}
      props={props}
      filterKey={props.type.filterKey}
    />
  );
};

export default SimpleSelector;